module.exports = __webpack_public_path__ + "static/Az-9ff0723703ed6b38854c75419b274294.png";